import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import CustomButton from './../Forms/CustomButton/CustomButton';
import './Modal.scss';

const PaperComponent = (props) => {
    return (
        <Draggable>
            <Paper { ...props } />
        </Draggable>
    );
}

const Modal = ({
    modalOpen, toggleModal, title, children, confirm, disabled, noActions
}) => (
        <Dialog
            open={modalOpen}
            onClose={() => toggleModal(false)}
            // PaperComponent={ PaperComponent }
            aria-labelledby='draggable-dialog-title'
            className='Dialog'
            PaperProps={{
                classes: {
                    root: 'dialog-root'
                }
            }}
        >
            <DialogTitle id='draggable-dialog-title' className='dialog-title'><span>{title}</span>
                <CustomButton type="button" iconOnly iconName="cross" name="Close" onClick={() => toggleModal(false)} />
            </DialogTitle>
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    confirm();
                    toggleModal(false);
                }}
            >
                <DialogContent className='dialog-content'>{children}</DialogContent>
                {!noActions && (
                    <DialogActions className='dialog-actions'>
                        <CustomButton
                            name='Cancel'
                            onClick={() => toggleModal(false)}
                            outline
                            plain
                        />
                        <CustomButton
                            name={title}
                            type="submit"
                            disabled={disabled}
                        />
                    </DialogActions>
                )}
            </form>
        </Dialog>
    );

Modal.propTypes = {
    modalOpen: PropTypes.bool,
    disabled: PropTypes.bool,
    toggleModal: PropTypes.func,
    title: PropTypes.string,
    children: PropTypes.instanceOf(Object),
    confirm: PropTypes.func,
    noActions: PropTypes.bool
};

Modal.defaultProps = {
    modalOpen: false,
    disabled: true,
    toggleModal: () => {},
    title: '',
    children: {},
    confirm: () => {},
    noActions: false
};

export default Modal;


// WEBPACK FOOTER //
// ./common/Modal/Modal.js